import ArticleService from "../services/ArticleService";
import { setDBLoadingState } from "../slices/db";
import store from "../store";
import { db } from "./db";

export const fillArticleCuttingSpecsStdTable = () => {
    return db.articleCuttingSpecsStd.count(async function (count: number) {
        if (count > 0) {
            //ArticlesSpec already populated
        } else {
            //ArticlesSpec Database is empty. Populating from ajax call...
            store.dispatch(setDBLoadingState(true));
            await ArticleService.getArticleCuttingsSpecsStd()
                .then((data) => {
                    //console.log(data)
                    //Got ajax response. We'll now add the objects.
                    //Calling bulkAdd() to insert objects...
                    if (data) {
                        return db.articleCuttingSpecsStd.bulkAdd(data);
                    }
                })
                .then(() => {
                    //Done populating.
                    return db.timestamps.add({ name: "articleCuttingSpecsStd", timestamp: String(new Date()) })
                }).catch(err => console.log(err))

        }
    })
}


export const deleteArticleCuttingSpecsStdTable = async () => {
    return db.articleCuttingSpecsStd.clear().then(() => {
        //console.log("Database successfully cleared");
    }).catch((err) => {
        //console.error("Could not clear database");
    })
}

export const updateArticleCuttingSpecsStdTable = async () => {
    await ArticleService.getArticleCuttingsSpecsStd()
        .then(async (data) => {
            await deleteArticleCuttingSpecsStdTable().then(() => {
                //@ts-ignore
                return db.articleCuttingSpecsStd.bulkPut(data);
            })
        })
        .catch(err => console.log(err));
}